export default __webpack_public_path__ + "static/media/398.50b3c7aa.gif";